import { setInstitutionDetail } from 'stores/station';

import { Institution } from 'modules/institutions/core/type';

import { apiCall } from 'hooks/service';

export const getInstitutionDetail = async (id: string) => {
  const result: Institution = await apiCall({
    url: `/institutions/${id}`,
    method: 'GET',
    isLoading: true,
    showError: true,
  });

  if (result?.id) {
    setInstitutionDetail(result);
  }
};
